export const APPLY_REWARD_GENERIC_ERROR_CODES = [
  'NETWORK_ERROR',
  'REWARD_MULTIPLE_ERRORS',
] as const;

export const APPLY_REWARD_ERROR_CODES = [
  ...APPLY_REWARD_GENERIC_ERROR_CODES,
  'REWARD_NOT_APPLICABLE',
  'REWARD_EXPIRED',
  'REWARD_NOT_FOUND',
  'RESTAURANT_NOT_ACCEPTING_ORDERS',
  'MISSING_SKU',
  'PRICE_MINIMUM',
  'PRICE_MAXIMUM',
  'TIME_RESTRICTION',
  'CHANNEL_RESTRICTION',
  'DAY_RESTRICTION',
] as const;

export const APPLY_REWARD_ERROR_MESSAGES_CONTENT_TYPE = 'applyRewardErrorMessages';

// ─── Types ───────────────────────────────────────────────────────────────────

export type ApplyRewardErrorMessages = Record<ApplyRewardErrorCode, string>;
export type ApplyRewardGenericErrorCode = (typeof APPLY_REWARD_GENERIC_ERROR_CODES)[number]; // prettier-ignore
export type ApplyRewardErrorCode = (typeof APPLY_REWARD_ERROR_CODES)[number];
